/**
 * VVS Motion Tokens
 * ─────────────────
 * Global animation constants for the entire site.
 * Based on Awwwards-level motion design principles.
 */

import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';

// Register GSAP plugins
gsap.registerPlugin(CustomEase);

// Create custom easings
const createEasings = () => {
  try {
    CustomEase.create("vvs-organic", "0.25, 0.46, 0.12, 1.0");
    CustomEase.create("vvs-wave", "0.16, 1.1, 0.3, 1.0");
    CustomEase.create("vvs-smooth", "0.43, 0.13, 0.23, 0.96");
    CustomEase.create("vvs-bounce", "0.34, 1.56, 0.64, 1");
  } catch (e) {
    // Easings already registered
  }
};

createEasings();

export const VVS_MOTION = {
  // ═══════════════════════════════════════════════════════════
  // DURATIONS (seconds)
  // ═══════════════════════════════════════════════════════════
  fast: 0.3,
  normal: 0.6,
  slow: 1.0,
  cinematic: 1.6,
  
  // ═══════════════════════════════════════════════════════════
  // EASINGS
  // ═══════════════════════════════════════════════════════════
  enter: "power3.out",
  exit: "power3.in",
  spring: "back.out(1.7)",
  elastic: "elastic.out(1, 0.4)",
  organic: "vvs-organic",
  wave: "vvs-wave",
  smooth: "vvs-smooth",
  bounce: "vvs-bounce",
  
  // ═══════════════════════════════════════════════════════════
  // SCROLL TRIGGER OFFSETS
  // ═══════════════════════════════════════════════════════════
  triggerStart: "top 85%",
  triggerCenter: "top 60%",
  triggerTop: "top top",
  
  // ═══════════════════════════════════════════════════════════
  // STAGGER VALUES
  // ═══════════════════════════════════════════════════════════
  staggerFast: 0.03,
  staggerNormal: 0.06,
  staggerSlow: 0.1,
  staggerCinematic: 0.15,
  
  // ═══════════════════════════════════════════════════════════
  // PARALLAX SPEEDS (scroll multipliers)
  // ═══════════════════════════════════════════════════════════
  parallax: {
    background: 0.3,
    midground: 0.7,
    foreground: 1.0,
  },
  
  // ═══════════════════════════════════════════════════════════
  // INTENSITY LEVELS (for mobile reduction)
  // ═══════════════════════════════════════════════════════════
  intensity: {
    desktop: 1.0,
    mobile: 0.6,
  },
};

// Check for reduced motion preference
export const prefersReducedMotion = () => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

// Check if mobile
export const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768 || 'ontouchstart' in window;
};

// Get intensity multiplier based on device
export const getIntensity = () => {
  if (prefersReducedMotion()) return 0;
  return isMobile() ? VVS_MOTION.intensity.mobile : VVS_MOTION.intensity.desktop;
};

export default VVS_MOTION;
